import React from "react";
import "./card/CardText";

export default function TextTitle(props) {

  return (
    <div 
    style={{
      color: "white",
      backgroundColor: "black",
      textAlign: "center",
      overflow: "hidden",
      padding: "1vw 1vw"
    }}>
       {props.textTitle.split("\r\n\r\n").map((p, i) => (
        <div
          key={i}
          style={{
            color:  "white",
            fontWeight: "bold",
            fontSize: props.isMobile ? "5vw" : "20px",
            textAlign: "center",
            margin: props.isMobile? "1vw 5vw":"5px 10vw 10px 10vw",
            padding: props.isMobile? "5vw 10vw":"5px 10vw 10px 10vw",
            //textDecorationLine: i===0 ?"underline": "none",
          }}
        >
        {p}
        <br/>
      </div>
      ))}
        <i
              style={{
                height: "20px",
                width: "20px",
                backgroundColor: "#d8e2eb",
                borderRadius: "50%",
                display: "inline-block",
              }}
            />
    </div>
  );
}
